// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:50:37

export default {
  "id": "cube-combo",
  "slug": "cube-combo",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/cd1e8ed33c0640098f4cd41ccf252c63-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/cd1e8ed33c0640098f4cd41ccf252c63/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Cube Combo",
      "description": "CubeCombo is a casual puzzle game. In this game, players need to use their wits by moving blocks with numbers, and merge the same blocks together until only one block is left, to complete the challenge. When only one number block is left in the panel or the target number block is synthesized, the current level is passed and a new level is opened.",
      "instructions": "Drag the blocks to combine the same numbers until the composition goal is complete",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "block",
        "drag",
        "heal"
      ]
    },
    "zh-CN": {
      "title": "立方连击",
      "description": "CubeCombo是一款休闲益智游戏。在这款游戏中，玩家需要通过移动带有数字的方块，运用智慧将相同的方块合并，直到只剩下一个方块，以完成挑战。当面板中只剩下一个数字方块或目标数字方块被合成时，当前关卡通过，并开启新关卡。",
      "instructions": "将方块拖动以组合相同的数字，直到完成合成目标",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "阻挡",
        "拖拽",
        "治疗"
      ]
    },
    "zh-TW": {
      "title": "立方連組",
      "description": "CubeCombo 是一款輕鬆的益智遊戲。在這款遊戲中，玩家需要利用智慧移動帶有數字的方塊，並將相同的方塊合併，直到只剩下一個方塊，以完成挑戰。當面板中只剩下一個數字方塊或目標數字方塊被合併時，當前關卡通過，並開啟新關卡。",
      "instructions": "將方塊拖動以合併相同的數字，直到達到組合目標為止",
      "genres": [
        "隨意",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "阻擋",
        "拖動",
        "治療"
      ]
    },
    "zh-HK": {
      "title": "立方連擊",
      "description": "CubeCombo 是一款輕鬆益智遊戲。在這款遊戲中，玩家需要運用智慧移動帶有數字的方塊，將相同的方塊合併，直到只剩下一個方塊為止，以完成挑戰。當面板中只剩下一個數字方塊或目標數字方塊被合併時，當前關卡通過並開啟新關卡。",
      "instructions": "將方塊拖移至一齊，直到達到組合目標",
      "genres": [
        "輕鬆",
        "謎題"
      ],
      "tags": [
        "1玩家",
        "阻擋",
        "拖移",
        "治療"
      ]
    },
    "ja": {
      "title": "キューブコンボ",
      "description": "CubeComboはカジュアルパズルゲームです。このゲームでは、プレイヤーは数字のブロックを動かして知恵を使い、同じブロックを合体させ、最後に一つのブロックだけが残るまでをクリアする必要があります。パネルに一つの数字ブロックだけが残っている場合または目標の数字ブロックが合成された場合、現在のレベルがクリアされ、新しいレベルが開かれます。",
      "instructions": "ブロックをドラッグして同じ数字を組み合わせ、構成目標を達成するまで続けます",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "ブロック",
        "ドラッグ",
        "ヒール"
      ]
    },
    "ko": {
      "title": "큐브 커뮤bo",
      "description": "CubeCombo는 캐주얼 파uzzle 게임입니다. 이 게임에서는 숫자가 있는 블록을 이동하여 지혜를 사용하여 같은 블록을 합쳐서 하나의 블록만 남게 하여 도전을 완료해야 합니다. 패널에 숫자 블록이 하나만 남거나 목표 숫자 블록이 합성되면 현재 레벨을 통과하고 새로운 레벨이 열립니다.",
      "instructions": "블록을 드래그하여 같은 숫자를 결합하여 구성 목표를 완료하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "블록",
        "드래그",
        "치유"
      ]
    },
    "fr": {
      "title": "Combinaison de cubes",
      "description": "CubeCombo est un jeu de puzzle casual. Dans ce jeu, les joueurs doivent utiliser leur esprit pour déplacer des blocs numériques, fusionner les mêmes blocs jusqu'à ce qu'il ne reste qu'un seul bloc, et ainsi terminer le défi. Lorsque seul un bloc numérique reste sur le plateau ou que le bloc cible est synthétisé, le niveau actuel est réussi et un nouveau niveau est ouvert.",
      "instructions": "Tirez les blocs pour combiner les mêmes nombres jusqu'à ce que l'objectif de composition soit accompli.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "bloquer",
        "glisser",
        "soigner"
      ]
    }
  }
};
